import {
  actionTypes,
  officeRequestSuccess,
  officeRequestFailure,
  userRequestSuccess,
  userRequestFailure,
  officeEntitlementRequestSuccess,
  officeEntitlementRequestFailure,
  entitlementRequestSuccess,
  entitlementRequestFailure,
  createRequestSuccess,
  createRequestFailure,
  baoEntitlementRequestSuccess,
  baoEntitlementRequestFailure,
  sodConflictsActionSuccess,
  sodConflictsActionFailure,
  officePaginatedEntitlementRequestSuccess,
  officePaginatedEntitlementRequestFailure,
  officePaginatedBrRequestSuccess,
  officePaginatedBrRequestFailure,
} from "./actions";

import {
  fetchOfficeRequest,
  fetchUserRequest,
  fetchOfficeEntitlementRequest,
  fetchEntitlementRequest,
  fetchCreateRequest,
  fetchBAOEntitlementRequest,
  getPaginatedEntitlementRequestService,
  getPaginatedBusinessRoleRequestService,
} from "./services";
import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import { fetchSODConflicts } from "../../../common/SODUtils/SODservices";

const fetchOfficeRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.OFFICE_REQUEST),
    mergeMap(() =>
      fetchOfficeRequest().pipe(
        map((response: any) => officeRequestSuccess(response)),
        catchError((error: any) => of(officeRequestFailure(error)))
      )
    )
  );

const fetchUserRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.USER_REQUEST),
    mergeMap((action: any) =>
      fetchUserRequest(action.id).pipe(
        map((response: any) => userRequestSuccess(response)),
        catchError((error: any) => of(userRequestFailure(error)))
      )
    )
  );

const fetchOfficeEntitlementRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.OFFICE_ENTITLEMENT_REQUEST),
    mergeMap((action: any) =>
      fetchOfficeEntitlementRequest(action.id).pipe(
        map((response: any) => officeEntitlementRequestSuccess(response)),
        catchError((error: any) => of(officeEntitlementRequestFailure(error)))
      )
    )
  );

const fetchEntitlementRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ENTITLEMENT_REQUEST),
    mergeMap((action: any) =>
      fetchEntitlementRequest(action.selectedUsers).pipe(
        map((response: any) => entitlementRequestSuccess(response)),
        catchError((error: any) => of(entitlementRequestFailure(error)))
      )
    )
  );

const fetchCreateRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_REQUEST),
    mergeMap((action: any) => {
      return fetchCreateRequest(action.abilitationObj).pipe(
        map(() => createRequestSuccess()),
        catchError((error: any) => of(createRequestFailure(error)))
      );
    })
  );

const fetchBAOEntitlementEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.BAO_ENTITLEMENT_REQUEST),
    mergeMap((action: any) =>
      fetchBAOEntitlementRequest(action.id).pipe(
        map((response: any) => baoEntitlementRequestSuccess(response)),
        catchError((error: any) => of(baoEntitlementRequestFailure(error)))
      )
    )
  );

const fetchSODConflictsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SOD_CONFLICTS),
    mergeMap((action: any) =>
      fetchSODConflicts(action.payload).pipe(
        map((response: any) => sodConflictsActionSuccess(response)),
        catchError((error: any) => of(sodConflictsActionFailure(error)))
      )
    )
  );

const fetchPaginatedOfficeEntitlementsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.OFFICE_PAGINATED_ENTITLEMENT_REQUEST),
    mergeMap((action: any) =>
      getPaginatedEntitlementRequestService(action.payload).pipe(
        map((response: any) =>
          officePaginatedEntitlementRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(officePaginatedEntitlementRequestFailure(error))
        )
      )
    )
  );

const fetchPaginatedOfficeBrsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.OFFICE_PAGINATED_BR_REQUEST),
    mergeMap((action: any) =>
      getPaginatedBusinessRoleRequestService(action.payload).pipe(
        map((response: any) => officePaginatedBrRequestSuccess(response)),
        catchError((error: any) => of(officePaginatedBrRequestFailure(error)))
      )
    )
  );

export default [
  fetchOfficeRequestsEpic,
  fetchUserRequestEpic,
  fetchOfficeEntitlementRequestEpic,
  fetchEntitlementRequestEpic,
  fetchCreateRequestEpic,
  fetchBAOEntitlementEpic,
  fetchSODConflictsEpic,
  fetchPaginatedOfficeEntitlementsEpic,
  fetchPaginatedOfficeBrsEpic,
];
